var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recap-slider" }, [
    _c(
      "div",
      { ref: "recapPagination", staticClass: "recap-slider__pagination" },
      [
        !_vm.isLoading
          ? _vm._l(_vm.itemCount, function(item) {
              return _c(
                "button",
                {
                  key: item,
                  staticClass: "recap-slider__pagination-item",
                  class: _vm.paginationClasses(item),
                  on: {
                    click: function($event) {
                      return _vm.handlePaginationItemClick(item)
                    }
                  }
                },
                [
                  _c("span", { style: _vm.paginationProgress(item) }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item) +
                        "\n                "
                    )
                  ])
                ]
              )
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "recapCarousel", staticClass: "recap-slider__carousel" },
      [
        _vm.isLoading
          ? _c("IntroductionSlide", { attrs: { isLoading: true } })
          : [
              _c("IntroductionSlide", {
                attrs: { isActive: _vm.currentIndex === 0 && !_vm.isFirstPlay }
              }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.new_contacts.question"),
                  isActive: _vm.currentIndex === 1
                }
              }),
              _vm._v(" "),
              _vm.showNewContactsSlide
                ? _c("ZoomSlide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.new_contacts", {
                        br: "<br>"
                      }),
                      listLine1: _vm.newContactsLine1,
                      listLine2: _vm.newContactsLine2,
                      isActive: _vm.currentIndex === 2
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noNewContactsText,
                      url:
                        "https://go.sellsy.com/academy-videos/contacts-gestion-organisation-et-suivi",
                      isActive: _vm.currentIndex === 2
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.top_cities.question"),
                  isActive: _vm.currentIndex === 3
                }
              }),
              _vm._v(" "),
              _vm.formattedTopCities.length > 0
                ? _c("Top3Slide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.top_cities.title"),
                      list: _vm.formattedTopCities,
                      isActive: _vm.currentIndex === 4
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noNewContactsText,
                      url:
                        "https://help.sellsy.com/fr/articles/5866824-voir-les-societes-sur-une-carte",
                      isActive: _vm.currentIndex === 4
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.activities.question"),
                  isActive: _vm.currentIndex === 5
                }
              }),
              _vm._v(" "),
              _vm.showActivitiesZoomSlide
                ? _c("ZoomSlide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.activities_zoom.title", {
                        br: "<br>"
                      }),
                      listLine1: _vm.activitiesZoomLine1,
                      listLine2: _vm.activitiesZoomLine2,
                      isActive: _vm.currentIndex === 6
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noActivitiesZoomText,
                      url:
                        "https://help.sellsy.com/fr/collections/3286091-suivez-l-activite-de-vos-equipes",
                      isActive: _vm.currentIndex === 6
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.productive_month.question"),
                  isActive: _vm.currentIndex === 7
                }
              }),
              _vm._v(" "),
              _vm.showTopMonthActivities
                ? _c("TopMonthActivitiesSlide", {
                    attrs: {
                      title: _vm.$t.__(
                        "recap.slider.most_productive_month.title"
                      ),
                      month: _vm.getMonth,
                      activities: _vm.topMonthActivities,
                      isActive: _vm.currentIndex === 8
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noTopMonthActivitiesText,
                      url: "/activities/all",
                      isActive: _vm.currentIndex === 8
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.impact.question"),
                  isActive: _vm.currentIndex === 9
                }
              }),
              _vm._v(" "),
              _vm.showImpactSlide
                ? _c("Top1Slide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.annual_results.title"),
                      icon: _vm.getImpactSlideInformation.icon,
                      value: _vm.getImpactSlideInformation.value,
                      label: _vm.getImpactSlideInformation.label,
                      isActive: _vm.currentIndex === 10
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noImpactSlideText,
                      url: "https://go.sellsy.com/academy?category=Facturation",
                      isActive: _vm.currentIndex === 10
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.top3_months.question"),
                  isActive: _vm.currentIndex === 11
                }
              }),
              _vm._v(" "),
              _vm.showBestMonths
                ? _c("Top3Slide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.best_months.title"),
                      list: _vm.formattedBestMonths,
                      unit: _vm.data.currency,
                      isActive: _vm.currentIndex === 12
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noBestMonthsText,
                      url:
                        "https://help.sellsy.com/fr/articles/9127872-rapport-rentabilite-de-vos-opportunites",
                      isActive: _vm.currentIndex === 12
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.best_clients.question"),
                  isActive: _vm.currentIndex === 13
                }
              }),
              _vm._v(" "),
              _vm.showBestClient
                ? _c("Top1Slide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.best_client.title"),
                      icon: _vm.getBestClientInformation.icon,
                      value: _vm.getBestClientInformation.value,
                      label: _vm.getBestClientInformation.label,
                      isActive: _vm.currentIndex === 14
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noBestClientText,
                      url:
                        "https://help.sellsy.com/fr/articles/7192257-rapport-les-clients-fideles-et-moins-fideles",
                      isActive: _vm.currentIndex === 14
                    }
                  }),
              _vm._v(" "),
              _c("QuestionSlide", {
                attrs: {
                  question: _vm.$t.__("recap.slider.best_products.question"),
                  isActive: _vm.currentIndex === 15
                }
              }),
              _vm._v(" "),
              _vm.showBestProducts
                ? _c("Top3Slide", {
                    attrs: {
                      title: _vm.$t.__("recap.slider.best_products.title", {
                        br: "<br>"
                      }),
                      list: _vm.formattedBestProducts,
                      unit: _vm.data.currency,
                      isActive: _vm.currentIndex === 16
                    }
                  })
                : _c("SellsyAcademySlide", {
                    attrs: {
                      text: _vm.noBestProductsText,
                      url:
                        "https://help.sellsy.com/fr/articles/5866573-ajouter-des-produits-et-services-a-mon-catalogue",
                      isActive: _vm.currentIndex === 16
                    }
                  }),
              _vm._v(" "),
              _c("FinalSlide", {
                attrs: {
                  title: _vm.$t.__("recap.slider.FinalSlide.title1"),
                  isActive: _vm.currentIndex === 17
                }
              }),
              _vm._v(" "),
              _c("FinalSlide", {
                attrs: {
                  title: _vm.$t.__("recap.slider.FinalSlide.title2"),
                  hasButton: true,
                  isActive: _vm.currentIndex === 18
                }
              })
            ]
      ],
      2
    ),
    _vm._v(" "),
    !_vm.isLoading
      ? _c(
          "div",
          {
            staticClass:
              "recap-slider__navigation-container recap-slider__navigation-container--prev"
          },
          [
            _c(
              "button",
              {
                ref: "prevButton",
                staticClass:
                  "recap-slider__navigation recap-slider__navigation--prev",
                attrs: { disabled: _vm.currentIndex === 0 },
                on: { click: _vm.showPrev }
              },
              [_c("CompassIcon", { attrs: { icon: "arrow-left" } })],
              1
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c(
          "div",
          {
            staticClass:
              "recap-slider__navigation-container recap-slider__navigation-container--next"
          },
          [
            _c(
              "button",
              {
                ref: "nextButton",
                staticClass:
                  "recap-slider__navigation recap-slider__navigation--next",
                attrs: { disabled: _vm.currentIndex === _vm.itemCount - 1 },
                on: { click: _vm.showNext }
              },
              [_c("CompassIcon", { attrs: { icon: "arrow-right" } })],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }